import { CreditCard } from 'lucide-react';
import { formatIban } from '../utils/entity-formatters';
import { InvestorEntityBankDetails } from '../services/investor-service';

interface BankDetailsProps {
  bankDetails: InvestorEntityBankDetails;
}

export function BankDetails({ bankDetails }: BankDetailsProps) {
  return (
    <>
      <div className="flex items-center justify-between mb-4">
        <h4 className="font-medium flex items-center">
          <CreditCard className="h-4 w-4 mr-1" />
          Bank Details
        </h4>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 text-sm">
        {/* IBAN anchors an IBAN account; a non-IBAN (e.g. US) account has none,
            so only show the field when it carries a value. */}
        {bankDetails.iban && (
          <div>
            <span className="block text-muted-foreground font-medium mb-1">
              IBAN
            </span>
            <p className="font-mono font-semibold text-primary text-base">
              {formatIban(bankDetails.iban)}
            </p>
          </div>
        )}
        <div>
          <span className="block text-muted-foreground font-medium mb-1">
            Bank
          </span>
          <p className="text-foreground">{bankDetails.bankName}</p>
        </div>
        <div>
          <span className="block text-muted-foreground font-medium mb-1">
            Account Holder
          </span>
          <p className="text-foreground">{bankDetails.accountHolder}</p>
        </div>

        {bankDetails.accountNumber && (
          <div>
            <span className="block text-muted-foreground font-medium mb-1">
              Account Number
            </span>
            <p className="font-mono text-foreground">
              {bankDetails.accountNumber}
            </p>
          </div>
        )}
        {bankDetails.swift && (
          <div>
            <span className="block text-muted-foreground font-medium mb-1">
              SWIFT/BIC
            </span>
            <p className="font-mono text-foreground">{bankDetails.swift}</p>
          </div>
        )}
        {bankDetails.bankCountry && (
          <div>
            <span className="block text-muted-foreground font-medium mb-1">
              Bank Country
            </span>
            <p className="text-foreground">{bankDetails.bankCountry}</p>
          </div>
        )}
        {bankDetails.bankAddress && (
          <div>
            <span className="block text-muted-foreground font-medium mb-1">
              Bank Address
            </span>
            <p className="text-foreground">{bankDetails.bankAddress}</p>
          </div>
        )}
      </div>
    </>
  );
}
